import React from 'react';
import Lottie from 'react-lottie';
import {
  Box,
  Text,
  Heading,
  Button,
} from '@chakra-ui/react';
import { FcGoogle } from 'react-icons/fc';
import { FaApple } from 'react-icons/fa';
import { BiLogoMicrosoftTeams } from "react-icons/bi";
import animationData from '../assets/AnimationCom.json';

interface BookingSuccessProps {
  onClose: () => void;
  appointmentDetails: {
    title: string;
    description: string;
    startTime: string;
    endTime: string;
    location: string;
  } | null;
}

const BookingSuccess: React.FC<BookingSuccessProps> = ({ onClose, appointmentDetails }) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };


  const handleReturnHome = () => {
    // bookingFlowStore.resetFlow();
    
    onClose();
    window.location.reload();
  };

  const createICalLink = () => {
    if (!appointmentDetails) return '';
    const { title, description, startTime, endTime, location } = appointmentDetails;
    const icsData = `BEGIN:VCALENDAR
    VERSION:2.0
    BEGIN:VEVENT
    SUMMARY:${title}
    DESCRIPTION:${description}
    DTSTART:${startTime.replace(/[-:]/g, '')}Z
    DTEND:${endTime.replace(/[-:]/g, '')}Z
    LOCATION:${location}
    END:VEVENT
    END:VCALENDAR`;
    const blob = new Blob([icsData], { type: 'text/calendar' });
    return URL.createObjectURL(blob);
  };

  const createGoogleCalendarLink = () => {
    if (!appointmentDetails) return '';
    const { title, description, startTime, endTime, location } = appointmentDetails;
    return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(title)}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&dates=${startTime.replace(/[-:]/g, '')}Z/${endTime.replace(/[-:]/g, '')}Z`;
  };

  const createMicrosoftTeamsLink = () => {
    if (!appointmentDetails) return '';
    const { title, description, startTime, endTime, location } = appointmentDetails;
    return `https://outlook.office.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(description)}&startdt=${startTime}&enddt=${endTime}&location=${encodeURIComponent(location)}`;
  };

  return (
          <Box textAlign="center">
            <Heading as="h3" mt={10} size="lg">
              Booking Successful!
            </Heading>
            <Lottie options={defaultOptions} height={300} width={300} />
            <Text fontSize="lg" mt={4}>
              Your appointment has been booked successfully.
            </Text>
            <Text fontSize="md" mt={1}>
              Add to your calendar.
            </Text>
            {appointmentDetails && (
              <Box mt={4}>
                <Button
                  as="a"
                  href={createICalLink()}
                  download="appointment.ics"
                  leftIcon={<FaApple />}
                  aria-label="Add to iCal"
                  variant="ghost"
                  borderRadius={30}
                  size="md"
                >
                  iCal
                </Button>
                <Button
                  as="a"
                  href={createGoogleCalendarLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  ml={2}
                  leftIcon={<FcGoogle />}
                  aria-label="Add to Google Calendar"
                  variant="ghost"
                  borderRadius={30}
                  size="md"
                >
                  Calendar
                </Button>
                <Button
                  as="a"
                  href={createMicrosoftTeamsLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  ml={2}
                  leftIcon={<BiLogoMicrosoftTeams />}
                  aria-label="Add to Microsoft Teams Calendar"
                  variant="ghost"
                  borderRadius={30}
                  size="md"
                >
                  MS Teams
                </Button>
              </Box>
            )}
            <Button
              bg="#B92F2F"
              color="#fff"
              borderRadius={30}
              size="md"
              fontSize="sm"
              mt={5}
              mb={5}
              onClick={handleReturnHome}
            >
              Return to Home
            </Button>
          </Box>
  );
};

export default BookingSuccess;
